import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-white rounded-lg shadow-lg p-8" }
const _hoisted_2 = { class: "text-center mb-8" }
const _hoisted_3 = { class: "text-3xl font-bold text-gray-800 mb-4" }
const _hoisted_4 = { class: "grid md:grid-cols-2 gap-6" }
const _hoisted_5 = { class: "flex items-start mb-4" }
const _hoisted_6 = { class: "flex-1" }
const _hoisted_7 = { class: "font-semibold text-gray-800 mb-1" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = { class: "text-sm text-gray-700" }
const _hoisted_12 = { class: "flex flex-wrap gap-2 mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('certifications.title')), 1),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "w-20 h-1 bg-gradient-to-r from-blue-600 to-purple-600 mx-auto rounded" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.certifications, (certification) => {
        return (_openBlock(), _createElementBlock("div", {
          key: certification.id,
          class: "bg-gray-50 rounded-lg p-6 hover:shadow-md transition-shadow border"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "w-12 h-12 rounded-lg flex items-center justify-center text-2xl mr-4",
              style: _normalizeStyle({ backgroundColor: certification.color + '20' })
            }, _toDisplayString(certification.icon), 5),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h3", _hoisted_7, [
                (certification.url)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: certification.url,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      class: "text-blue-600 hover:underline"
                    }, _toDisplayString(certification.name), 9, _hoisted_8))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(certification.name), 1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("p", _hoisted_11, _toDisplayString(certification.description), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(certification.skills, (skill) => {
              return (_openBlock(), _createElementBlock("span", {
                key: skill,
                class: "inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded"
              }, _toDisplayString(skill), 1))
            }), 128))
          ])
        ]))
      }), 128))
    ])
  ]))
}